// HANDLE PRODUCTS MEGA MENU
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow, classVideoToHide) {
	var videoWrapper = document.querySelector(classVideoToHide);
	if (videoWrapper) {
		videoWrapper.classList.remove('mm-visible');
		const video = videoWrapper.querySelector('video');
		if (video) {
			video.pause();
		}
	}

	var imageContainers = document.querySelectorAll(classElemsToHide);
	imageContainers.forEach(function (imageContainer) {
		imageContainer.classList.remove('mm-visible');
	});
	document.querySelector(classElemToShow).classList.add('mm-visible');
}

// HANDLE VIDEOS MEGA MENU
function mmMegaMenuShowVideo(classElemsToHide, classVideoToToggle) {
	var productLists = document.querySelectorAll(classElemsToHide);
	productLists.forEach(function (productList) {
		productList.classList.remove('mm-visible');
	});

	var videoWrapper = document.querySelector(classVideoToToggle);
	if (videoWrapper) {
		videoWrapper.classList.add('mm-visible');
		const video = videoWrapper.querySelector('video');
		if (video) {
			video.play();
		}
	}
}

function playVideo(videoToPlay) {
	const video = document.querySelector(videoToPlay);
	if (video) {
		video.play();
	}
	console.log("playing");
}

function pauseVideo(videoToPause) {
	const video = document.querySelector(videoToPause);
	if (video) {
		video.pause();
	}
}

// HANDLE MEGA MENU POSITION
function getMegaMenuPosition() {
	var menuElems = document.querySelectorAll('.mm-header-link');
	var header = document.querySelector('.mm-header');
	var headerHeight = header.offsetHeight;

	menuElems.forEach(function (menuElem) {
		if (menuElem.nextElementSibling) {
			if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper')) {
				menuElem.nextElementSibling.style.top = `calc(${headerHeight}px)`;
			}
		}
	});
}

// HANDLE MEGA MENU ACTIF
function toggleHeaderClass(header, topHeader) {
	header.addEventListener('mouseenter', function () {
		topHeader.classList.add('mm-header-scrolled');
		this.classList.add('mm-header-scrolled');
	});

	header.addEventListener('mouseleave', function () {
		const drawer = document.querySelector('.mm-drawer-cart-filter');
		const search = document.querySelector('.mm-header-search-container');
		const headerHeight = header.offsetHeight;
		if (!(drawer && drawer.classList.contains('mm-dc-is-open')) && window.scrollY < window.innerHeight - headerHeight && (search.classList.contains('mm-close'))) {
			topHeader.classList.remove('mm-header-scrolled');
			this.classList.remove('mm-header-scrolled');
		}
		// mmHideSearch();
	});
}

function toggleMegaMenuClass(filter, links, header) {
	links.forEach((link) => {
		link.addEventListener('mouseenter', function () {
			filter.classList.add('active');
			document.querySelector('html').classList.add('stop-scrolling');
		});
	});

	header.addEventListener('mouseleave', function () {
		const drawer = document.querySelector('.mm-drawer-cart-filter');
		if (drawer && drawer.classList.contains('mm-dc-is-open')) {
			filter.classList.add('active');
		} else {
			filter.classList.remove('active');
		}
		
		document.querySelector('html').classList.remove('stop-scrolling');
	});
}

// MEGA MENU CHANGE ON LINK HOVER
function initCursorDetection() {
	if (window.innerWidth > 992) {
		const announcementBar = document.querySelector('.mm-section-announcement-bar');
		var mmHeader = document.querySelector('.mm-header');
		var logo = document.getElementById('hero_banner_logo');
		const linksMega = document.querySelectorAll('.mm-link-mega-active');
		const MegaMenuFilter = document.querySelector('.mm-filter-mega-menu');

		if (!logo) {
			toggleHeaderClass(mmHeader, announcementBar);
			toggleMegaMenuClass(MegaMenuFilter, linksMega, mmHeader);
			return;
		}

		var logoTop = logo.getBoundingClientRect().top;

		if (!mmHeader) {
			console.log("L'élément n'a pas été trouvé.");
			return;
		}

		if (logoTop >= 20) {
			toggleHeaderClass(mmHeader, announcementBar);
			toggleMegaMenuClass(MegaMenuFilter, linksMega, mmHeader);
		}
	}
}

// MENU ON HOVER
function updateHeaderBackground() {
	var header = document.querySelector('.mm-header');
	var annonceBar = document.querySelector('.mm-section-announcement-bar');
	var logo = document.getElementById('hero_banner_logo');

	if (!logo) {
		function checkScroll() {
			var annonceBarHeight = annonceBar.offsetHeight;

			if (window.scrollY >= annonceBarHeight) {
				header.classList.add('mm-header-scrolled');
			} else {
				header.classList.remove('mm-header-scrolled');
			}
		}
		window.addEventListener('scroll', checkScroll);
		return;
	}

	var logoTop = logo.getBoundingClientRect().top;

	if (logoTop <= 20) {
		header.classList.add('mm-header-scrolled');
	} else {
		header.classList.remove('mm-header-scrolled');
	}
}

// HANDLE MOBILE MENU OPEN
function mmMobileMenu() {
    stopLenis();
	const announcementBar = document.querySelector('.mm-section-announcement-bar');
	const header = document.querySelector('header');
	var headerMenu = document.querySelector('.mm-header');
	var headerHeight = headerMenu.offsetHeight;
	var headerMenuTop = headerMenu.getBoundingClientRect().top;

	const icon = document.querySelector('.mm-header-burger');
	const mobileMenu = document.querySelector('.mm-mobile-menu-wrapper');
	document.querySelector('html').classList.add('stop-scrolling');

	header.classList.add('mm-open');
	icon.classList.add('mm-open');
	mobileMenu.classList.add('mm-menu-open');
	announcementBar.classList.add('mm-header-scrolled');
	headerMenu.classList.add('mm-header-scrolled');
	mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
}

// HANDLE MOBILE MENU CLOSE
function mmCloseMobileMenu() {
    startLenis();
	const announcementBar = document.querySelector('.mm-section-announcement-bar');
	const header = document.querySelector('header');
	var headerMenu = document.querySelector('.mm-header');
	const icon = document.querySelector('.mm-header-burger');
	const mobileMenu = document.querySelector('.mm-mobile-menu-wrapper');
	document.querySelector('html').classList.remove('stop-scrolling');

	header.classList.remove('mm-open');
	icon.classList.remove('mm-open');
	mobileMenu.classList.remove('mm-menu-open');
	
	var headerHeight = header.offsetHeight;

	if (window.scrollY >= window.innerHeight - headerHeight) {
		announcementBar.classList.add('mm-header-scrolled');
		headerMenu.classList.add('mm-header-scrolled');
	} else {
		setTimeout(() => {
			announcementBar.classList.remove('mm-header-scrolled');
			headerMenu.classList.remove('mm-header-scrolled');
		}, '650');
		
	}
}

// MOBILE MENU - SHOW SOUS MENU
function mmMobileMenuShowNext(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

function mmMobileMenuShowPrev(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

// HANDLE PRODUCT RECO
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
                .then(productCardSlidersInit)
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}
}

// HANDLE SEARCH

function mmShowSearch(trigger) {
	// Trouver le conteneur de recherche le plus proche
	const searchContainer = trigger.nextElementSibling;
	const allSearchContainers = document.querySelectorAll('.mm-header-search-container');
	const allSearchTriggers = document.querySelectorAll('.mm-header-icon-search-trigger');
	const searchFilter = document.querySelector('.mm-filter-search'); // Nouveau sélecteur

  
	// Fermer tous les autres conteneurs de recherche
	allSearchContainers.forEach(container => {
	  if (container !== searchContainer) {
		container.classList.add('mm-close');
	  }
	});
  
	// Réinitialiser tous les triggers
	allSearchTriggers.forEach(searchTrigger => {
	  if (searchTrigger !== trigger) {
		searchTrigger.classList.add('mm-close');
	  }
	});
  
	// Basculer l'état du conteneur de recherche actuel
	searchContainer.classList.toggle('mm-close');
	trigger.classList.toggle('mm-close');
  
	// Gérer le filtre
	if (!searchContainer.classList.contains('mm-close')) {
		searchFilter.classList.add('active');
		document.querySelector('html').classList.add('stop-scrolling');
	  } else {
		searchFilter.classList.remove('active');
		document.querySelector('html').classList.remove('stop-scrolling');
	  }
  
	// Focus sur le champ de recherche
	if (!searchContainer.classList.contains('mm-close')) {
	  const searchInput = searchContainer.querySelector('input[type="search"]');
	  if (searchInput) {
		searchInput.focus();
	  }
	}
  }
  
  function mmHideSearch() {
	// Sélectionner tous les conteneurs de recherche et triggers
	const searchContainers = document.querySelectorAll('.mm-header-search-container');
	const searchTriggers = document.querySelectorAll('.mm-header-icon-search-trigger');
	const searchFilter = document.querySelector('.mm-filter-search');
	const predictiveSearch = document.querySelector('predictive-search'); // Ajout du sélecteur predictive-search
  
	// Fermer tous les conteneurs de recherche
	searchContainers.forEach(container => {
	  container.classList.add('mm-close');
	});
  
	// Réinitialiser tous les triggers
	searchTriggers.forEach(trigger => {
	  trigger.classList.add('mm-close');
	});
  
	// Désactiver le filtre
	searchFilter.classList.remove('active');
	document.querySelector('html').classList.remove('stop-scrolling');
  
	// Vider et fermer la recherche prédictive
	if (predictiveSearch) {
	  // Dispatch un événement personnalisé pour fermer la recherche prédictive
	  predictiveSearch.dispatchEvent(new CustomEvent('clear-search'));
	  
	  // Cache le conteneur des résultats
	  const resultsContainer = predictiveSearch.querySelector('.predictive-search__results-list');
	  if (resultsContainer) {
		resultsContainer.style.display = 'none';
	  }
	}
  
	// Vider tous les champs de recherche
	const searchInputs = document.querySelectorAll('input[type="search"]');
	searchInputs.forEach(input => {
	  input.value = '';
	});
  }
  
  document.addEventListener('DOMContentLoaded', function() {
	const predictiveSearch = document.querySelector('predictive-search');
	if (predictiveSearch) {
	  predictiveSearch.addEventListener('clear-search', function() {
		const input = this.querySelector('input[type="search"]');
		if (input) {
		  input.value = '';
		  input.dispatchEvent(new Event('input'));
		}
	  });
	}
  });

function mmDetectHideSearch() {
	const search = document.querySelector('.mm-header-search-container');
	window.addEventListener('scroll', function () {
		if (!(search.classList.contains('mm-close'))) {
			mmHideSearch();
		}
	});
	window.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			mmHideSearch();
		}
	});
}

// FILTERS
function mmShowDrawerInfos(popup, clickedElem) {
	var filter = document.querySelector('.mm-filter-mega-menu');
	document.querySelector(popup).classList.add("mm-dc-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
	clickedElem.classList.toggle('mm-close');

	if (clickedElem.classList.contains('mm-close')) {
		filter.classList.remove('active');
		filter.style.zIndex = "5";

	} else {
		filter.classList.add('active');
		filter.style.zIndex = "20";
	}
}

function mmHideDrawerInfos(popup) {
	var filter = document.querySelector('.mm-filter-mega-menu');
	document.querySelector(popup).classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
	document.querySelector('.mm-filter-count-container').classList.add('mm-close');
	filter.classList.remove('active');
	filter.style.zIndex = "5";
	productCardSlidersInit();
}

// MOBILE DRAWER HEIGHT
const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
};

// DROPOWN
customElements.define('product-recommendations', ProductRecommendations);

function animatedDropdowns() {
	const faqColl = document.querySelectorAll('.mm-faq-collapsible');
	let q;

	for (q = 0; q < faqColl.length; q++) {
		faqColl[q].addEventListener('click', function () {
			this.classList.toggle('active');

			const content = this.nextElementSibling;

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + 'px';
			}
		});
	}
}

// Target blank External links
function externalLink() {
	var links = document.querySelectorAll('a');
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}
};

function handleDropdown() {
    const dropWrapper = document.querySelectorAll('.mm-drop-wrapper');

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            // dropWrapper.forEach((el) => {
            //     if (el !== this) {
            //         el.classList.remove('active');
            //         el.nextElementSibling.style.maxHeight = null;
            //     }
            // });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });

    // Open the first dropdown by default
    if (dropWrapper.length > 0) {
        const firstDrop = dropWrapper[0];
        firstDrop.classList.add('active');
        const firstContent = firstDrop.nextElementSibling;
        if (firstContent) {
            firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
        }
    }
}


document.addEventListener('DOMContentLoaded', (event) => {
	getMegaMenuPosition();
	initCursorDetection();
	mmDetectHideSearch();
	handleDropdown();
	externalLink();
});

window.addEventListener('DOMContentLoaded', (event) => {
	animatedDropdowns();
});

window.addEventListener('scroll', updateHeaderBackground);
window.addEventListener('resize', documentHeight);
documentHeight();

/*---------- ANIMATIONS ----------*/

//scrollTrigger plugin registration
gsap.registerPlugin(ScrollTrigger);

// Déclaration Lenis
var lenis = new Lenis({
	duration: 1.2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
	direction: 'vertical',
	gestureDirection: 'vertical',
	lerp: 0.075,
	smooth: 2,
	smoothTouch: false,
	touchMultiplier: 2,
	wheelMultiplier: 1,
	infinite: false,
	autoResize: true,
});

lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
	ScrollTrigger.update();
}

requestAnimationFrame(raf);

// Disable Lenis when overing div with overflow:scroll
function stopLenis() {
	// console.log('stop');
	document.querySelector('html').classList.add('stop-scrolling');
	lenis.destroy();
}

// Fonction appelée quand la souris quitte l'élément
function startLenis() {
	lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: 'vertical',
		gestureDirection: 'vertical',
		lerp: 0.05,
		smooth: 2,
		smoothTouch: false,
		touchMultiplier: 2,
		wheelMultiplier: 1,
		infinite: false,
		autoResize: true,
	});

	lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
		ScrollTrigger.update();
	}

	requestAnimationFrame(raf);
}

function setupLenis() {
	// Ajout des écouteurs d'événements sur l'élément
	var elements = document.querySelectorAll('.stop-lenis');

	elements.forEach(function (element) {
		if (window.innerWidth > 992) {
			element.addEventListener('mouseenter', stopLenis);
			element.addEventListener('mouseleave', startLenis);
		}
	});
}
setupLenis();

// HERO BANNER
const sectionHero = document.querySelector('.mm-section-hero-banner');
if (sectionHero) {
    const logoWrapper = sectionHero.querySelector('.mm-hero-banner-logo-wrapper');
    if (logoWrapper) {
        var logoWidthPixels = window.innerWidth < 1000 ? 72 : 130;
        var start = window.innerWidth < 768 ? 'bottom bottom-=15%' : 'bottom bottom';

        gsap.to(logoWrapper, {
            y: '-40dvh',
            width: logoWidthPixels,
            ease: 'none',
            scrollTrigger: {
                trigger: sectionHero,
                start: start,
                end: 'bottom center',
                scrub: 1,
            },
        });
    } else {
        console.log("Le logo n'existe pas");
    }
}

// IMAGE CONTENT ZOOM
const sectionImageContent = document.querySelector('.mm-text-image-content');
if (sectionImageContent) {
    const imageContent = sectionImageContent.querySelector('.mm-image-section-animated-image');
	var startPoint;
	var endPoint;
	if (window.innerWidth < 993) {
		startPoint = 'center';
		endPoint = 'bottom';
	} else if (window.innerWidth > 1440) {
		startPoint = 'top';
		endPoint = 'bottom';
	} else {
		startPoint = 'center-=20%';
		endPoint = 'bottom';
	}
    if (imageContent) {
        gsap.to(imageContent, {
            clipPath: 'inset(0% 0%)',
			objectFit: 'cover',
			ease: 'none',
            scrollTrigger: {
                trigger: sectionImageContent,
                start: `top ${startPoint}`,
                end: `bottom ${endPoint}`,
                scrub: 1
            },
        });
    } else {
        console.log("L'image n'existe pas");
    }
}

// PARALAX CONTENT PAGE
const images = document.querySelectorAll(".mm-section-ti-parallax");
images.forEach((slideImage) => {
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-1 .mm-section-text-image-parallax-image"), {
		yPercent: -30,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true
		}
	});
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-2 .mm-section-text-image-parallax-image"), {
		yPercent: -15,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true
		}
	});
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-3 .mm-section-text-image-parallax-image"), {
		yPercent: -60,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true
		}
	});
});

// PRODUCT CARDS SLIDERS
function productCardSlidersInit() {
    const sliders = document.querySelectorAll('.mm-pc-slider');

    if (!sliders.length) return;

    sliders.forEach(function (slider) {
        const card = slider.closest('.mm-product-card');
        let isDragging = false;
        let start = 0;
        let end = 0;
        let startTime = 0;
        let images = slider.querySelectorAll('.mm-pc-slider-image');
        let index = 0;
        let progressBar = slider.querySelector('.mm-pc-slider-progress-bar');
        let isDesktop = window.innerWidth >= 769;
        let hasMoved = false;

        // Si il n'y a qu'une seule image, on n'initialise pas les contrôles du slider
        if (images.length <= 1) {
            if (images[0]) images[0].style.opacity = '1';
            return;
        }
        // Récupérer les boutons de navigation
        const prevButton = slider.querySelector('.mm-pc-slider-prev');
        const nextButton = slider.querySelector('.mm-pc-slider-next');
        const slidesContainer = slider.querySelector('.mm-pc-slides');

        function resetCard() {
            images.forEach((img) => (img.style.opacity = '0'));
            if (progressBar) {
                progressBar.style.width = '0%';
            }
            index = 0;
        }

        function updateImage() {
            if (!images.length) return;
            
            images.forEach((img) => (img.style.opacity = '0'));
            images[index].style.opacity = '1';
            
            if (progressBar) {
                progressBar.style.width = `${((index + 1) / images.length) * 100}%`;
            }
        }

        // Gestion des clics sur les flèches
        if (prevButton) {
            prevButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                index = index - 1 < 0 ? images.length - 1 : index - 1;
                updateImage();
                return false; // Empêche la propagation
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                index = (index + 1) % images.length;
                updateImage();
                return false; // Empêche la propagation
            });
        }

        // Empêcher la propagation des clics sur les boutons vers le lien parent
        if (slidesContainer) {
            [prevButton, nextButton].forEach(button => {
                if (button) {
                    button.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                }
            });
        }

        function handleDragStart(event) {
            if (event.target.closest('.mm-pc-slider-prev') || event.target.closest('.mm-pc-slider-next')) {
                return;
            }
            isDragging = true;
            hasMoved = false;
            start = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
            startTime = Date.now();
            end = start;
        }

        function handleDragging(event) {
            if (!isDragging) return;
            
            const currentX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
            const moveDistance = Math.abs(currentX - start);
            
            if (moveDistance > 5) {
                hasMoved = true;
                event.preventDefault();
            }
            
            end = currentX;
        }

        function handleDragEnd(event) {
            if (!isDragging) return;
            
            const endTime = Date.now();
            const timeElapsed = endTime - startTime;
            const moveDistance = Math.abs(end - start);
            
            isDragging = false;

            if (!hasMoved && timeElapsed < 300 && moveDistance < 10) {
                if (event && event.ctrlKey) {
                    window.open(card.dataset.url, '_blank');
                } else {
                    window.location.href = card.dataset.url;
                }
                return;
            }

            const diff = start - end;
            const minSwipeDistance = 30;

            if (Math.abs(diff) >= minSwipeDistance) {
                if (diff > 0) {
                    index = (index + 1) % images.length;
                } else {
                    index = index - 1 < 0 ? images.length - 1 : index - 1;
                }
                updateImage();
            }
        }

        // Mobile
        slider.addEventListener('touchstart', handleDragStart, { passive: true });
        slider.addEventListener('touchmove', handleDragging);
        slider.addEventListener('touchend', handleDragEnd);

        // Desktop
        slider.addEventListener('mousedown', handleDragStart);
        slider.addEventListener('mousemove', handleDragging);
        slider.addEventListener('mouseup', handleDragEnd);
        slider.addEventListener('mouseleave', handleDragEnd);

        if (isDesktop) {
            card.addEventListener('mouseenter', () => {
                index = 1;
                updateImage();
            });

            card.addEventListener('mouseleave', () => {
                resetCard();
            });
        } else {
            updateImage();
        }
    });
}

// SEARCH CARDS SLIDERS
function searchSplideProducts() {
	var id = '.splide-predictive-search';
	var splideElem = document.querySelector(id);
	var bar = splideElem.querySelector( '.my-slider-progress-bar' );

	var splide = new Splide( splideElem, {
		type: 'slide',
		arrows: false,
		pagination: false,
		omitEnd: true,
		gap: 5,
		perPage: 2,
		perMove: 1,
		destroy: true,
		breakpoints: {
			700: {
				destroy: false,
				fixedWidth: 175,
				perPage: false,
				perMove: 2
			}
		}
	})

	splide.on( 'mounted move', function () {
		var end  = splide.Components.Controller.getEnd() + 1;
		var rate = Math.min( ( splide.index + 1 ) / end, 1 );
		bar.style.width = String( 100 * rate ) + '%';
	});

	splide.mount();
}

function checkScreenSizeAndInit() {
	productCardSlidersInit();
}

document.addEventListener('DOMContentLoaded', checkScreenSizeAndInit);
window.addEventListener('resize', checkScreenSizeAndInit);

// SIZE CHART
function mmOpenSC(imageUrl, title, price, comparePrice, productId, productUrl = '#') {
    document.querySelector('.mm-size-chart-wrapper').classList.remove('mm-hidden');
    document.body.style.overflow = 'hidden';
    document.querySelector('html').classList.add('stop-scrolling');
    
    // Mettre à jour les informations du produit
    document.getElementById('mmSCProductImage').src = imageUrl;
    document.getElementById('mmSCProductTitle').textContent = title;
    document.getElementById('mmSCProductPrice').textContent = price;
    document.getElementById('mmSCProductLink').href = productUrl || '#';
    
    if (comparePrice && comparePrice !== price) {
        document.getElementById('mmSCProductComparePrice').textContent = comparePrice;
        document.getElementById('mmSCProductComparePrice').style.display = 'block';
    } else {
        document.getElementById('mmSCProductComparePrice').style.display = 'none';
    }

    // Mettre à jour le contenu metafield via data attribute
    const metafieldContent = document.querySelector(`[data-product-metafield="${productId}"]`);
    if (metafieldContent) {
        document.getElementById('mmSCMetafieldContent').innerHTML = metafieldContent.innerHTML;
    }
}

function mmCloseSC() {
    document.querySelector('.mm-size-chart-wrapper').classList.add('mm-hidden');
    document.body.style.overflow = '';  // Réactiver le scroll
    document.querySelector('html').classList.remove('stop-scrolling');
    
    // Retirer le filtre
    document.body.classList.remove('mm-filter-active');
    
    if (window.innerWidth < 768) {
        document.querySelector('.mm-section-header').classList.remove('mm-none');
    }
}

// Ajout du filtre et ouverture du size chart
function addFilterAndOpenSC(event) {
    document.body.classList.add('mm-filter-active');
    
    mmOpenSC(event);
}

function afficherTableauMesures() {
    const tableauMesures = document.querySelectorAll('.mm-size-chart-measurements');
    const tableauConversions = document.querySelectorAll('.mm-size-chart-internationnals-conversions');
    const tableauMesuresTitle = document.querySelector('.mm-size-chart-measurements-title');
    const tableauConversionsTitle = document.querySelector('.mm-size-chart-internationnal-title');

    // Afficher les tableaux de mesures et cacher les tableaux de conversions
    tableauMesures.forEach(tableau => tableau.style.display = 'block');
    tableauConversions.forEach(tableau => tableau.style.display = 'none');

    // Mettre à jour le style des titres
    tableauMesuresTitle.classList.add('mm-underline');
    tableauMesuresTitle.classList.remove('mm-black-20');
    tableauConversionsTitle.classList.add('mm-black-20');
    tableauConversionsTitle.classList.remove('mm-underline');
}

function afficherTableauConversions() {
    const tableauMesures = document.querySelectorAll('.mm-size-chart-measurements');
    const tableauConversions = document.querySelectorAll('.mm-size-chart-internationnals-conversions');
    const tableauMesuresTitle = document.querySelector('.mm-size-chart-measurements-title');
    const tableauConversionsTitle = document.querySelector('.mm-size-chart-internationnal-title');

    // Afficher les tableaux de conversions et cacher les tableaux de mesures
    tableauConversions.forEach(tableau => tableau.style.display = 'block');
    tableauMesures.forEach(tableau => tableau.style.display = 'none');

    // Mettre à jour le style des titres
    tableauConversionsTitle.classList.add('mm-underline');
    tableauConversionsTitle.classList.remove('mm-black-20');
    tableauMesuresTitle.classList.add('mm-black-20');
    tableauMesuresTitle.classList.remove('mm-underline');
}

// Ajouter les écouteurs d'événements sur les titres
document.querySelector('.mm-size-chart-measurements-title').addEventListener('click', afficherTableauMesures);
document.querySelector('.mm-size-chart-internationnal-title').addEventListener('click', afficherTableauConversions);


// PRODUCT CARD VARIANT SELECTOR MOBILE
function openPCVariantSelector(variantId, productHandle) {
	const selector = document.querySelector(`[data-variant-selector-wrapper="${productHandle}"]`);
	if (selector) {
	  selector.classList.remove('mm-hidden');
	}
}
  
function closePCVariantSelector(productHandle) {
	const selector = document.querySelector(`[data-variant-selector-wrapper="${productHandle}"]`);
	if (selector) {
	  selector.classList.add('mm-hidden');
	  
	  // Réinitialiser l'opacité de l'image principale après la fermeture
	  const card = document.querySelector(`.mm-product-card-${productHandle}`);
	  if (card) {
		const slider = card.querySelector('.mm-pc-slider');
		if (slider) {
			const images = slider.querySelectorAll('.mm-pc-slider-image');
			if (images.length > 0) {
				// Réinitialiser toutes les images à opacity 0
				images.forEach(img => img.style.opacity = '0');
				// Mettre la première image à opacity 1
				images[0].style.opacity = '1';
			}
		}
	  }
	}
}


// Forcer vidéos en autoplay
// document.addEventListener("DOMContentLoaded", function () {	
// 	document.querySelectorAll("video").forEach(video => {
// 	  video.muted = true; // iOS exige que l'autoplay soit muet
// 	  video.play().catch(error => console.log("Autoplay bloqué :", error));
// 	});
// });










